module.exports = __webpack_public_path__ + "img/map.d9ec881d.svg";